import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function Select({
  label,
  value,
  onChange,
  placeholder,
  allowEmpty = false,
  options,
  disabled = false,
  className,
}: {
  label?: string;
  value: string;
  onChange?: (value: string) => void;
  allowEmpty?: boolean;
  placeholder?: string;
  options: { label: string; value: string; disabled?: boolean }[];
  disabled?: boolean;
  className?: string;
}) {
  return (
    <div className={`relative ${className ?? ""}`}>
      {label && (
        <label
          className={`block text-sm font-medium ${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-500"}`}
        >
          {label}
        </label>
      )}
      <select
        className="w-full border-1 border-gray-300 rounded-xs p-2 bg-white disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
        disabled={disabled}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      >
        {placeholder && (
          <option disabled value="">
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option
            key={option.value}
            disabled={option.disabled}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
      {allowEmpty && value !== "" && (
        <button
          className="absolute right-5 top-7 cursor-pointer"
          type="button"
          onClick={() => onChange?.("")}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </div>
  );
}
